// var baseUrl = 'http://localhost:8080/';
// const baseUrl = 'http://trivia-8-1.us-east-2.elasticbeanstalk.com/';
const baseUrl = 'https://animetrivia.xyz/';

export default baseUrl;


// WEBPACK FOOTER //
// ./src/components/constants/config.js